import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1094272"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_form_inline_entry = _resolveComponent("base-form-inline-entry")!
  const _component_base_typography = _resolveComponent("base-typography")!

  return (_openBlock(), _createBlock(_component_base_typography, { subtitle3: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_form_inline_entry, {
        class: "base-input-container",
        label: _ctx.label,
        description: _ctx.description,
        textAlign: _ctx.textAlign,
        formEntryValue: _ctx.modelValue || undefined,
        staticLabel: _ctx.staticLabelComputed,
        errorMessage: _ctx.errorMessage
      }, {
        default: _withCtx(() => [
          _createElementVNode("input", _mergeProps({ class: "ava-form-item-with-text-input" }, _ctx.$attrs, {
            value: _ctx.modelValue,
            ref: "avaInput",
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateModelValue && _ctx.updateModelValue(...args))),
            placeholder: _ctx.placeholder
          }), null, 16, _hoisted_1),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["label", "description", "textAlign", "formEntryValue", "staticLabel", "errorMessage"])
    ]),
    _: 3
  }))
}